import { FC } from 'react'
import { Form } from 'antd'
import Title from 'antd/es/typography/Title'
import useWatch from '../../hooks/use-watch'
import calcStampCost, { StampSpecs } from '../../../../../helpers/calculations/calc-stamp-cost'
import CountUp from 'react-countup'
import { usePrevious } from 'react-use'

interface CostProps {}

const Cost: FC<CostProps> = () => {
    const width = useWatch('width') || 0
    const length = useWatch('length') || 0
    const shape = useWatch('shape')
    const floods = useWatch('floods') || 0
    const roller = useWatch('roller')
    const labelsInFlood = roller ? JSON.parse(roller).numberOfLabels : 0
    const specs: StampSpecs = {
        width: width,
        length: length,
        floods: +floods,
        labelsInFlood: labelsInFlood,
        // @ts-ignore
        shape: shape,
    }
    const cost = calcStampCost(specs)
    const prevCost = usePrevious(cost)

    return (
        <Form.Item label={'Цена'}>
            <Title style={{ margin: 0, lineHeight: 1, fontWeight: 'bold' }} level={3}>
                <CountUp
                    start={prevCost}
                    end={cost}
                    separator={' '}
                    suffix={' руб'}
                    duration={0.75}
                />
            </Title>
        </Form.Item>
    )
}

export default Cost
